import { OPERATIONS } from './apiModules'

const OPERATION_PREFIX = `${OPERATIONS}/setting`
import { actionUpload, post, get } from '@/utils/request'

export function uploadImg(file) {
  return actionUpload(`${OPERATION_PREFIX}/uploadImg`, file)
}

export function getIndexConfig() {
  return get(`${OPERATION_PREFIX}/getHomePageSetting`)
}

export function setIndexConfig(
  params = {
    bannerImg: '',
    bannerLink: '',
    modules: []
  }
) {
  return post(`${OPERATION_PREFIX}/setHomePageSetting`, params)
}

export function getInsidePageSetting() {
  return get(`${OPERATION_PREFIX}/getInsidePageSetting`)
}

export function setInsidePageSetting(
  params = {
    bannerImg: '',
    bannerLink: '',
    quickLinks: []
  }
) {
  return post(`${OPERATION_PREFIX}/setInsidePageSetting`, params)
}
